// extracted by mini-css-extract-plugin
module.exports = {"NewLunchingline":"NewLunching_NewLunchingline__1kgrX","startYour":"NewLunching_startYour__2usv0"};